/**
 * Constantes pour le module classes
 */

export const MAX_CLASS_NAME_LENGTH = 64
export const MIN_MAX_STUDENTS = 1
export const MAX_MAX_STUDENTS = 200

/**
 * Messages d'erreur
 */
export const CLASS_ERRORS = {
  NOT_FOUND: 'Classe non trouvée',
  NOT_ACCESSIBLE: 'Classe non accessible',
  ALREADY_DELETED: 'Classe déjà supprimée',
  DUPLICATE_NAME:
    'Nom de classe déjà utilisé dans cet établissement et année scolaire',
  INVALID_LEVEL: 'Niveau invalide',
  INVALID_ESTABLISHMENT: 'Établissement invalide',
  INVALID_MAX_STUDENTS: "Nombre maximum d'élèves invalide",
  CREATION_FAILED: 'Erreur lors de la création',
  UPDATE_FAILED: 'Erreur lors de la mise à jour',
  DELETE_FAILED: 'Erreur lors de la suppression',
  HAS_STUDENTS: "Impossible de supprimer une classe contenant des élèves",
} as const

/**
 * Opérations pour les metrics
 */
export const CLASS_OPERATIONS = {
  CREATE: 'create_class',
  FIND_ALL: 'findMany_classes',
  FIND_ALL_PAGINATED: 'findMany_paginated_classes',
  FIND_ONE: 'findOne_class',
  FIND_BY_ESTABLISHMENT: 'findByEstablishment_classes',
  FIND_MEMBERSHIPS_PAGINATED: 'findMemberships_paginated',
  UPDATE: 'update_class',
  DELETE: 'delete_class',
} as const

/**
 * Messages de log pour les opérations
 */
export const CLASS_LOG_MESSAGES = {
  CREATING: (userId: string, name: string) =>
    `[User ${userId}] Création classe: ${name}`,
  CREATED: (id: string) => `Class created successfully: ${id}`,
  UPDATING: (userId: string, id: string) =>
    `[User ${userId}] Mise à jour classe: ${id}`,
  UPDATED: (id: string) => `Class updated successfully: ${id}`,
  DELETING: (userId: string, id: string) =>
    `[User ${userId}] Suppression classe: ${id}`,
  DELETED: (id: string) => `Class deleted successfully: ${id}`,
  FOUND: (count: number, userId: string) =>
    `Found ${count} classes for user ${userId}`,
} as const

/**
 * Contextes d'erreur pour ServiceErrorHandler
 */
export const CLASS_ERROR_CONTEXTS = {
  CREATE: 'create class',
  FETCH_ALL: 'fetch classes',
  FETCH_ALL_PAGINATED: 'fetch classes paginated',
  FETCH_ONE: 'fetch class',
  FETCH_BY_ESTABLISHMENT: 'fetch classes by establishment',
  FETCH_MEMBERSHIPS_PAGINATED: 'fetch class memberships paginated',
  UPDATE: 'update class',
  DELETE: 'delete class',
} as const

/**
 * Actions PolicyEngine
 */
export const CLASS_POLICY_ACTIONS = {
  CREATE: 'class:create',
  VIEW: 'class:view',
  UPDATE: 'class:update',
  DELETE: 'class:delete',
} as const
